import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { MasterBrandsDropDownDto } from './master-brands-drop-down.dto';


export class MasterDropDownResponseModel extends GlobalResponseObject {
    data?: MasterBrandsDropDownDto[];
    
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data MasterBrandDTO[]
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: MasterBrandsDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}